import { isEqual, mapValues, noop, pick } from 'lodash/fp';

// exposes (value, key) as arguments to the mapping function instead of just (value)
const mapValuesWithKey = mapValues.convert({ cap: false });

export default function localStorageMiddleware() {
  // we're setting a bunch of fields on reducer to save as they change
  // this is getting called unnecessarily often...fix later
  // it will go reducer name => array of fields
  const storeFields = {
    lobbyChallenges: [
      'activeSport',
      'activeSubCategory',
      'activeCategory',
      'filters',
      'groupByKey',
      'sortField',
      'sortDescending'
    ],
    liveChallenges: ['activeSport', 'activeSubCategory'],
    settings: ['darkMode']
  };

  const save = window.localStorage
    ? state => {
        try {
          const data = {};
          Object.keys(storeFields).forEach(reducerName => {
            data[reducerName] = pick(storeFields[reducerName])(state[reducerName]);
          });
          window.localStorage.setItem('SFP_STORAGE', JSON.stringify(data));
        } catch (error) {
          // Ignore error, user just won't get persistent state
        }
      }
    : noop;

  const getSubstate = state => mapValuesWithKey((values, key) => pick(values)(state[key]));

  return ({ getState }) => next => action => {
    if (!window.localStorage) {
      return next(action);
    }

    const prevState = getState();
    const returnValue = next(action);
    const nextState = getState();

    const getPrevSubstate = getSubstate(prevState);
    const getNextSubstate = getSubstate(nextState);

    const diff = entries => !isEqual(getPrevSubstate(entries), getNextSubstate(entries));
    if (diff(storeFields)) {
      save(nextState);
    }

    return returnValue;
  };
}
